const power = {
  state: {
    structureTree: null,
    pointData : null,
  },
  mutations: {
    GET_STRUCTURE_TREE: (state, tree) => {
      state.structureTree = tree
    },
    GET_POINT_DATA: (state, data) => {
      state.pointData = data
    },
  },
  actions: {
    getStructureTree({ commit }, tree) {
      commit('GET_STRUCTURE_TREE', tree)
    },
    getPointData({ commit }, data){
      commit('GET_POINT_DATA', data)
    }
  }
}

export default power



// WEBPACK FOOTER //
// ./src/store/modules/power.js